import React from 'react';
import './Hero.css';

export default function Hero() {
  const heroImage = '/Personalphoto2.jpg';

  return (
    <section className="hero" id="top">
      <div className="hero__bg" aria-hidden />
      <div className="container hero__inner">
        <div className="hero__content">
          <div className="hero__eyebrow">
            PMP® · ITIL 4 · Scrum · Security+ · 7+ Years in Banking & FinTech
          </div>
          <h1 className="hero__title">
            Your product is late.
            <span className="hero__titleAccent"> Your systems are unstable.</span>
            <span className="hero__titleAccent"> I fix that.</span>
          </h1>
          <p className="hero__subtitle">
            I stabilize failing software projects and reduce IT downtime for startups and SMEs -
            using a structured, 3-step delivery framework. No vague plans. No wasted sprints. Just
            execution.
          </p>

          <div className="hero__ctaRow">
            <a className="hero__ctaPrimary" href="#work-with-me">
              Get a Free 30-Min Delivery Audit
            </a>
            <a className="hero__ctaSecondary" href="#services">
              See Entry Services
            </a>
          </div>

          <dl className="hero__highlights" aria-label="Highlights">
            <div className="hero__highlight">
              <dt>7+ years</dt>
              <dd>Banking, FinTech, IT services</dd>
            </div>
            <div className="hero__highlight">
              <dt>PMP® + ITIL 4</dt>
              <dd>Delivery + service management</dd>
            </div>
            <div className="hero__highlight">
              <dt>Agile · Scrum</dt>
              <dd>Sprint planning & execution</dd>
            </div>
          </dl>
        </div>

        <div className="hero__media" aria-label="Profile image">
          <div className="hero__mediaFrame">
            <img className="hero__image" src={heroImage} alt="Emmanuel Obeng" loading="eager" />
          </div>
        </div>
      </div>
    </section>
  );
}
